import React from 'react';
import { XR } from 'aws-amplify';

export default class SumerianScene extends React.Component {
  async componentDidMount() {
    await this.loadAndStartScene();
  }

  render() {
    return (
      <div>
        <div
          id="sumerian-scene-dom-id"
          style={{ height: '100vh', width: '100vw' }}
        />
      </div>
    );
  }

  async loadAndStartScene() {
    const progressCallback = (progress) => {
      // console.log(`Sumerian scene load progress: ${progress * 100}%`);
    };
    const sceneOptions = {
      progressCallback
    };
    await XR.loadScene(this.props.scene, 'sumerian-scene-dom-id', sceneOptions);
    const controller = XR.getSceneController(this.props.scene);
    this.props.onLoaded(controller);
    XR.start(this.props.scene);
  }
}
